import React, { useRef, useState, useEffect } from 'react'
import styles from './NoSelectPay.module.css'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { message, QRCode } from 'antd'
import qrcodeImg from './QR.svg'
export default function NoSelectPay(props) {
  const dispatch = useDispatch()
  const [confirmInfo, setConfirmInfo] = useState({})
  const [messageApi, contextHolder] = message.useMessage()
  return (
    <div className={styles.wechatPay}>
      <div className={styles.title2Div}>扫一扫积分充值</div>
      <div className={styles.title3Div}>**元</div>
      <img src={qrcodeImg} className={styles.qrcodeImg} />
    </div>
  )
}
// export default PaymentInfoList;

